<div class="filter-modal-container">
  <div class="filter-header">Filters</div>
  <div class="filter-container">
    <form [formGroup]="filterForm" class="filter-form">
      <ng-container *ngIf="openDropdowns">
        <emerald-dropdown
          [label]="'Primary Skills'"
          [outlined]="true"
          [isValid]="true"
          [multiSelect]="true"
          [showFilter]="true"
          formControlName="primarySkill"
          [options]="primarySkillOptions"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
          [id]="'primary_skills_select'"
        ></emerald-dropdown>
        <emerald-dropdown
          [label]="'Vendor'"
          [outlined]="true"
          [isValid]="true"
          formControlName="vendorName"
          [options]="vendorOptions"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
          [id]="'vendor_select'"
        ></emerald-dropdown>
        <emerald-dropdown
          [label]="'DOJ'"
          [outlined]="true"
          [isValid]="true"
          formControlName="month"
          [options]="monthOptions"
          [id]="'single_select'"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
        ></emerald-dropdown>
      </ng-container>

      <div class="button-container">
        <emerald-button
          [label]="'Reset'"
          [size]="'Small'"
          [type]="'Secondary'"
          (onClick)="reset()"
        ></emerald-button>
        <emerald-button
          [label]="'Apply'"
          [type]="'Primary'"
          (onClick)="opened = false; apply()"
        ></emerald-button>
      </div>
    </form>
  </div>
</div>